import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Disabled aggressive image preloading on navigation
 * Images will load naturally when needed instead of being preloaded
 */
const RouteImagePreloader: React.FC = () => {
  const location = useLocation();
  const initialLoad = useRef<boolean>(true);

  useEffect(() => {
    // Skip preloading completely - let images load naturally
    if (initialLoad.current) {
      initialLoad.current = false;
    }

    // No preloading on navigation - images load when actually needed
  }, [location.pathname]);

  // This component doesn't render anything and doesn't preload
  return null;
};

export default RouteImagePreloader;

